<template>
    <div class="progress">
        <div
            v-if="values.length === 0"
            :class="`progress-bar-${type}`"
            :aria-valuenow="value"
            :style="`width: ${value}%;`"
            class="progress-bar"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
        >
            <span class="sr-only">
                <slot></slot>
            </span>
        </div>
        <div
            v-for="(progress, index) in values"
            v-else
            :key="index"
            :class="`progress-bar-${progress.type}`"
            :style="`width: ${progress.value}%;`"
            class="progress-bar"
        >
            <span class="sr-only"></span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PProgress',
    props: {
        type: {
            type: String,
            default: 'default',
            description: 'Progress type (primary|info|danger|default|warning|success)'
        },
        value: {
            type: Number,
            default: 0,
            validator: (value) => {
                return value >= 0 && value <= 100
            },
            description: 'Progress single value (0 - 100)'
        },
        values: {
            type: Array,
            default: () => [],
            description: 'Progress multiple values, when showing multiple progress bars within one'
        }
    }
}
</script>
<style></style>
